import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { TrackerType, UserPatchType } from '@meniudigital/shared'
import Setting from '../Setting'
import { patchCurrentUser } from 'src/state/users'
import { IS_DESKTOP_OR_TABLET } from '../..'

const allTrackingServices = [
  {
    type: TrackerType.GoogleAnalytics,
    name: IS_DESKTOP_OR_TABLET ? 'Tracking cu Google Analytics' : 'Tracking Google Analytics',
    placeholder: `ID-ul proiectului tău (e.g. G-YMJ36VFP3W)`,
  },
  {
    type: TrackerType.MetaPixel,
    name: IS_DESKTOP_OR_TABLET ? 'Tracking cu Meta Pixel' : 'Tracking Meta Pixel',
    placeholder: `ID-ul proiectului tău (e.g. 123456789012345)`,
  },
]

export default function TrackingSetting() {
  const dispatch = useDispatch()

  const { user } = useSelector((state: State) => state.users)

  const isTrackerActive = (type: TrackerType) => {
    return (user?.tracking || []).some(x => x.type === type && x.isActive === true)
  }

  const toggleTrackerVisibility = (type: TrackerType) => {
    const currentSetting = (user?.tracking || []).find(x => x.type === type)!
    dispatch(
      patchCurrentUser({ type: UserPatchType.Tracking, data: { ...currentSetting, type, isActive: !currentSetting?.isActive } }),
    )
  }

  const updateTrackerId = (newId: string, type: TrackerType) => {
    const currentSetting = (user?.tracking || []).find(x => x.type === type)!

    dispatch(patchCurrentUser({ type: UserPatchType.Tracking, data: { ...currentSetting, type, id: newId } }))
  }

  if (!user) {
    return null
  }

  const hasActiveTracker = (user?.tracking || []).some(x => x.isActive)
  const infoMessage = hasActiveTracker
    ? 'Clienții tăi vor trebui să accepte un pop-up de consimțământ GDPR înaintea accesării meniului.'
    : 'Prin activarea unui tracker, clienții tăi vor trebui să accepte un pop-up de consimțământ GDPR înaintea accesării meniului.'

  return (
    <div className="settings-group">
      {allTrackingServices.map(({ type, name, placeholder }, index) => (
        <Setting
          key={type}
          title={name}
          iconPath={`/logos/${type}.svg`}
          isEnabled={isTrackerActive(type)}
          value={(user?.tracking || []).find(x => x.type === type)?.id}
          placeholder={placeholder}
          onValueUpdate={newValue => updateTrackerId(newValue, type)}
          onToggle={() => toggleTrackerVisibility(type)}
          toggleTexts={{ on: 'Activ', off: 'Inactiv' }}
          infoText={index === allTrackingServices.length - 1 ? infoMessage : undefined}
          infoVariant={index === allTrackingServices.length - 1 ? 'warning' : undefined}
          withBullet
        />
      ))}
    </div>
  )
}
